var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCultureLeisure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Base"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.999 44.1591C8.47618 44.1591 3.99902 39.6819 3.99902 34.1591C3.99902 28.6362 8.47618 24.1591 13.999 24.1591L25.999 24.1591V28.1591L13.999 28.1591C10.6853 28.1591 7.99902 30.8453 7.99902 34.1591C7.99902 37.4728 10.6853 40.1591 13.999 40.1591H37.999C39.1036 40.1591 39.999 39.2636 39.999 38.1591V20.1591C39.999 19.0545 39.1036 18.1591 37.999 18.1591L32.999 18.1591V14.1591L37.999 14.1591C41.3127 14.1591 43.999 16.8454 43.999 20.1591V38.1591C43.999 41.4728 41.3127 44.1591 37.999 44.1591H13.999Z",
    fill: "#15D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.999 24.1591C33.3127 24.1591 35.999 26.8453 35.999 30.1591C35.999 33.4728 33.3127 36.1591 29.999 36.1591H13.999C12.8945 36.1591 11.999 35.2636 11.999 34.1591C11.999 33.0545 12.8945 32.1591 13.999 32.1591H29.999C31.1036 32.1591 31.999 31.2636 31.999 30.1591C31.999 29.0545 31.1036 28.1591 29.999 28.1591L13.999 28.1591V24.1591L29.999 24.1591Z",
    fill: "#15D4B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99902 14.1591C3.99902 8.63621 8.47618 4.15906 13.999 4.15906H29.999C33.3127 4.15906 35.999 6.84535 35.999 10.1591V30.1591L31.999 30.1591V10.1591C31.999 9.05449 31.1036 8.15906 29.999 8.15906H13.999C10.6853 8.15906 7.99902 10.8453 7.99902 14.1591L7.99902 34.1591H3.99902L3.99902 14.1591Z",
    fill: "#15D4B6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCultureLeisure);
export default __webpack_public_path__ + "static/media/iconCultureLeisure.b307729f9bff7f649c35bbbfe7490745.svg";
export { ForwardRef as ReactComponent };